"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BffGetListLessonsEndpoint = exports.BffGetListAccountsEndpoint = exports.BffGetOneAccountEndpoint = exports.BffGetListUserServicesEndpoint = exports.BffGetOneUserServiceEndpoint = exports.BffGetContentEndpoint = exports.BffGetUserSchoolsEndpoint = exports.BffGetUserProfileEndpoint = exports.BffGetUserLessonsEndpoint = exports.BffGetUserCollectionsEndpoint = exports.BffGetUserServicesV2Endpoint = exports.BffGetUserServicesEndpoint = exports.BffGetUserCategoriesEndpoint = exports.BffGetSubjectsEndpoint = exports.BffGetLanguagesEndpoint = void 0;
__exportStar(require("./common-content-schema"), exports);
exports.BffGetLanguagesEndpoint = require("./get-languages");
exports.BffGetSubjectsEndpoint = require("./get-subjects");
exports.BffGetUserCategoriesEndpoint = require("./get-user-categories");
exports.BffGetUserServicesEndpoint = require("./get-user-services");
exports.BffGetUserServicesV2Endpoint = require("./get-user-services-v2");
exports.BffGetUserCollectionsEndpoint = require("./get-user-collections");
exports.BffGetUserLessonsEndpoint = require("./get-user-lessons");
exports.BffGetUserProfileEndpoint = require("./get-user-profile");
exports.BffGetUserSchoolsEndpoint = require("./get-user-schools");
exports.BffGetContentEndpoint = require("./get-content");
exports.BffGetOneUserServiceEndpoint = require("./get-one-user-service");
exports.BffGetListUserServicesEndpoint = require("./get-list-user-services");
exports.BffGetOneAccountEndpoint = require("./get-one-account");
exports.BffGetListAccountsEndpoint = require("./get-list-accounts");
exports.BffGetListLessonsEndpoint = require("./get-list-lessons");
